module.exports = __webpack_public_path__ + "img/img_paso2.83b265ee.png";